/**
 * TimelineWeekBackground Component
 *
 * Renders alternating week tints for visual week separation.
 * Even weeks are transparent, odd weeks have a subtle tint.
 */

import React, { useMemo } from 'react'
import { useTimelineStaticContext } from '../../context/timeline-static-context'
import { useTimelineStyles } from '../../../hooks/use-timeline-styles'
import { generateWeeksAndMonths } from '../../utils/timeline-date-utils'

/**
 * TimelineWeekBackground - Alternating week tints
 *
 * Creates visual separation between weeks using subtle background colors.
 */
export const TimelineWeekBackground = React.memo(() => {
  const { weekWidth, timelineDateRange, totalWeeks } = useTimelineStaticContext()
  const { WEEK_TINT_COLOR } = useTimelineStyles()

  // Generate weeks data
  const { weeks } = useMemo(
    () => generateWeeksAndMonths(timelineDateRange, totalWeeks),
    [timelineDateRange, totalWeeks]
  )

  return (
    <>
      {weeks.map((_, i) => (
        <rect
          key={i}
          x={i * weekWidth}
          y={0}
          width={weekWidth}
          height="100%"
          fill={WEEK_TINT_COLOR}
          visibility={i % 2 === 0 ? 'hidden' : 'visible'}
        />
      ))}
    </>
  )
})
